import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Base64 } from 'js-base64';
import { environment } from '@/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EquiposService {

  private endpoint: string | null;

  constructor
  (
    private httpClient: HttpClient
  ) 
  { 
    this.endpoint = Base64.decode(environment.apiEndpoint) + '/equipos/Equipos';
  }

  getEquipos(estacion: string){
    return this.httpClient.get( this.endpoint + '/ObtenerEquipos/' + estacion);
  }

  obtenerTipoEquipo(){
    return this.httpClient.get( this.endpoint + '/ObtenerTipoEquipo');
  }

  obtenerCondicionEquipo(){
    return this.httpClient.get( this.endpoint + '/ObtenerCondicionEquipo');
  }

  insertEquipo(modelo: any){
    return this.httpClient.post(this.endpoint + '/InsertEquipo', modelo);
  }

  updateEquipo(modelo: any){
    return this.httpClient.post(this.endpoint + '/UpdateEquipo', modelo);
  }

}
